import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from '../logo.svg';
import './Header.css';
import {useSavingsAuth} from "savings-js";

const Header: React.FC = () => {
  const { getUser, signOut } = useSavingsAuth();
  const user = getUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);
  
  // Get user initials
  const getUserInitials = () => {
    const firstInitial = user.name.charAt(0).toUpperCase();
    const lastInitial = user.lastName.charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  };

  const handleLogout = () => {
    signOut();
    navigate('/');
  };
  
  // Determine if a navigation link is active
  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest('.user-profile')) {
        setShowDropdown(false);
      }
    };
    
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="app-branding">
          <Link to="/home">
            <img src={logo} alt="Incentives Logo" className="app-logo" />
          </Link>
        </div>
        <nav className="header-nav">
          <Link to="/programs" className={`nav-link ${isActive('/programs') ? 'active' : ''}`}>
            Programs
          </Link>
          <Link to="/events" className={`nav-link ${isActive('/events') ? 'active' : ''}`}>
            Events
          </Link>
          
          <div className="user-profile">
            <div 
              className="user-avatar" 
              onClick={(e) => {
                e.stopPropagation();
                setShowDropdown(!showDropdown);
              }}
            >
              {getUserInitials()}
            </div>
            
            {showDropdown && (
              <div className="user-dropdown">
                <div className="user-info">
                  <div className="user-name">{user.name} {user.lastName}</div>
                  <div className="user-email">{user.email}</div>
                </div>
                <div className="dropdown-divider"></div>
                <Link to="/profile" className="dropdown-item">
                  <i className="fas fa-user-circle"></i> Profile
                </Link>
                <Link to="/settings" className="dropdown-item">
                  <i className="fas fa-cog"></i> Settings
                </Link>
                <div className="dropdown-divider"></div>
                <div className="dropdown-item logout-item" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt"></i> Logout
                </div>
              </div>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header; 